export const positionSelect = {
  select: `选择当前城市`,
  locating:"获取位置中..",
  noData:"暂无位置信息",
  NeedManulSelectForNoData: '无法访问位置信息，请尝试手动选择',
  relocation:"重新定位"
};
